import {DefaultTheme} from 'styled-components';
import {darken, mix, rgba} from 'polished';

import {black, white, chambray, ice, sapphire, night} from './colors';

export const Master: DefaultTheme = {
    svg: {
        authors: {
            backgroundColor: darken(0.05, white),
            foregroundColor: rgba(black, 0.2)
        }
    },
    profile: {
        background: `linear-gradient(180deg, ${sapphire} 0%, ${night} 100%)`,
        stroke: {
            icon: rgba(ice, 0.25),
            separator: rgba(ice, 0.08)
        }
    },
    color: {
        primary: chambray,
        secondary: white,
        foreground: black,
        background: white,
        breadcrumb: mix(0.265, black, white),
        label: mix(0.4, black, white)
    },
    font: {
        family: {
            primary: 'sans-serif',
            secondary: 'serif'
        },
        weight: {
            light: 300,
            normal: 400,
            bold: 600,
            heavy: 900
        }
    },
    breakpoint: {
        tablet: '768px',
        desktop: '1025px'
    }
};

// TODO: Dark theme variant
export const DarkTheme: DefaultTheme = Master;

// TODO: alternative theme converter
export const AlternativeTheme = (currentTheme: DefaultTheme): DefaultTheme => {
    return currentTheme;
};
